// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  agentId: __t.u64(),
  workspaceId: __t.u64(),
  remit: __t.string(),
  taskTagsJson: __t.string(),
  modelLanesJson: __t.string(),
  skillsJson: __t.string(),
  toolsJson: __t.string(),
  memoryPrivilegesJson: __t.string(),
  triggerContractJson: __t.string(),
  reactionContractJson: __t.string(),
  evidenceContractJson: __t.string(),
  rubricJson: __t.string(),
  characterBudget: __t.string(),
  safetyConstraintsJson: __t.string(),
};
